import React from 'react'
import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Card } from '@/components/ui/card'

interface LoadingStateProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
  variant?: 'default' | 'card'
}

export function LoadingState({ 
  text = 'Loading...', 
  variant = 'default',
  className, 
  ...props 
}: LoadingStateProps) {
  const content = (
    <>
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      <p className="text-sm font-medium text-muted-foreground">{text}</p>
    </>
  )

  if (variant === 'card') {
    return (
      <Card
        className={cn(
          'flex flex-col items-center justify-center space-y-4',
          'min-h-[200px] p-8',
          className
        )}
        {...props}
      >
        {content}
      </Card>
    )
  }

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center space-y-4',
        'min-h-[200px] p-8',
        className
      )}
      {...props}
    >
      {content}
    </div>
  )
}